import DisputeTransactionPage from "components/pages/DisputeTransactionPage";
import DisputeItemServiceView from "components/pages/DisputeTransactionPage/components/DisputeItemServiceView";
/**
 * @function DisputeItemServicePage
 * @param {OBJECT} data - Object to modify the data view.
 * @param {OBJECT} ui - Object to modify the ui of the view.
 * @return {React.Component}
 * @exported true
 * @description This page is a step in the dispute transactions workflow.
 * @example
 * <DisputeItemServicePage data={ data } ui={ ui } />
 */
export default function DisputeItemServicePage(props) {
    const data = props.data ? { data: props.data } : {};
    const ui = props.ui ? { ui: props.ui } : {};

    return (
        <DisputeTransactionPage 
        view={ <DisputeItemServiceView { ...data } { ...ui } /> }
        />
    );
}